<ng-container *ngIf="title">
  <h3>{{ title }}</h3>
</ng-container>

<table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td
      mat-cell
      *matCellDef="let row"
      [innerHtml]="row.name | highlight : term"
    ></td>
  </ng-container>
  <ng-container matColumnDef="module">
    <th mat-header-cell *matHeaderCellDef>Module</th>
    <td
      mat-cell
      *matCellDef="let row"
      [innerHtml]="row.moduleName | highlight : term"
    ></td>
  </ng-container>
  <ng-container matColumnDef="updatedDate">
    <th mat-header-cell *matHeaderCellDef>Updated Date</th>
    <td
      mat-cell
      *matCellDef="let row"
      [innerHtml]="(row.addedDate | date : dateFormat) + '' | highlight : term"
    ></td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnDefs"></tr>
  <tr
    mat-row
    (click)="itemClick.emit(row)"
    *matRowDef="let row; columns: columnDefs"
  ></tr>
</table>
<mat-paginator [length]="dataSource.data.length" [pageSize]="pageSize">
</mat-paginator>
